import { HeroStyled, LegendStyled } from '../onboardingStyles'

export const OnboardingHero = () => (
  <HeroStyled>
    <span className="eyebrow">
      <span className="dot" aria-hidden="true" /> Pending approval
    </span>
    <h1>
      Welcome to Nutrisense, <em>let&apos;s set up your coach profile.</em>
    </h1>
    <p>
      This is the profile your clients and our care team will see. You can save a draft and finish
      later. A manager will review and approve it before you start taking clients.
    </p>

    <LegendStyled aria-hidden="true">
      <span>
        <span className="req">*</span> indicates a required field
      </span>
      <span>·</span>
      <span>Optional fields are tagged</span>
    </LegendStyled>
  </HeroStyled>
)
